import styled from 'styled-components';
import Dialog from '../../HOC/Dialog/Dialog';
import { BodyBoldS, BodyRegularS, HeadingExtraBoldM } from '../../styles/globals';
import CategoryImage from '@/assets/images/individual-report-category-picture.svg?react';

export const Modal = styled(Dialog)`
  ${({ theme }) => `
    max-width: 768px;
    width: 100%;

    [id='BodyElem'] {
      padding: 
      0 
      calc(${theme.layout.spacing.giga} + ${theme.layout.spacing.mikro}) 
      calc(${theme.layout.spacing.giga} + ${theme.layout.spacing.mikro});

      @media ${theme.layout.breakpoints.max.tablet} {
        padding: 0 ${theme.layout.spacing.deka} calc(${theme.layout.spacing.giga} + ${theme.layout.spacing.mikro});
      }
    }

    @media ${theme.layout.breakpoints.max.tablet} {
      max-width: revert;
    }
  `};
`;

export const ContentCont = styled.div`
  ${({ theme }) => `
    display: flex;
    margin: 0 ${theme.layout.spacing.centy} 0 0;
    flex-flow: column nowrap;
    justify-content: center;
    gap: ${theme.layout.spacing.centy};
  `};
`;

export const ImageCont = styled.div`
  ${({ theme }) => `
    display: flex;
    margin: 0 0 0 ${theme.layout.spacing.centy};
    width: 100%;
    align-items: center;
    justify-content: center;

    @media ${theme.layout.breakpoints.max.tablet} {
      display: none;
    }
  `};
`;

export const Title = styled(HeadingExtraBoldM)`
  ${({ theme }) => `
    margin: 0;

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 20px;
      line-height: 23px;
    }
  `};
`;

export const Text = styled(BodyRegularS)`
  ${({ theme }) => `
    margin: 0;

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 14px;
      line-height: 16px;
    }
  `};
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ListItem = styled.li``;

export const Topic = styled(BodyBoldS)`
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[70]};

    @media ${theme.layout.breakpoints.max.tablet} {
      font-size: 14px;
      line-height: 16px;
    }
  `};
`;

export const Image = styled(CategoryImage)`
  height: 320px;
`;
